import { render, staticRenderFns } from "./StockConsumptionList.vue?vue&type=template&id=664a22ff&scoped=true&"
import script from "./StockConsumptionList.vue?vue&type=script&lang=js&"
export * from "./StockConsumptionList.vue?vue&type=script&lang=js&"
import style0 from "./StockConsumptionList.vue?vue&type=style&index=0&id=664a22ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a22ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VOverlay,VProgressCircular,VSkeletonLoader})
